module.exports = __webpack_public_path__ + "img/card3_min.b2ccf65c.png";